import React from 'react';
import { InputField } from './InputField';

export const InputObject = ({ title, inputs, onChange }) => {
  return (
    <div>
      <h4>{title}</h4>
      {inputs.map((input, idx) => (
        <InputField key={idx} input={input} onChange={onChange} />
      ))}
    </div>
  );
};
